// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4cAjd","active":"styles_active__ndUki","redBorder":"styles_redBorder__rPjjK"};